import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/AuthService';
import { AppButton } from '../../components/AppButton/AppButton';
import AuthLayout from '../../components/Auth/AuthLayout';
import AuthField from '../../components/Auth/AuthField';

const emailIcon = (
  <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
  </svg>
);

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ loading: false, message: '', error: false });

  async function onSubmit(event) {
    event.preventDefault();
    setStatus({ loading: true, message: '', error: false });

    try {
      const res = await requestPasswordReset(email);
      setStatus({
        loading: false,
        message: res?.message || 'If the email exists, a reset link has been sent.',
        error: false,
      });
    } catch (err) {
      console.error(err);
      const msg = err?.response?.data?.message || 'An error occurred while requesting password reset.';
      setStatus({ loading: false, message: msg, error: true });
    }
  }

  return (
    <AuthLayout
      title="Reset your password"
      description="Enter the email associated with your account and we'll send a reset link."
      footer={(
        <>
          Remembered your password?{' '}
          <Link to="/login" className="auth-link">Sign in</Link>
        </>
      )}
    >
      <form onSubmit={onSubmit}>
        <AuthField
          id="email"
          label="Email"
          type="email"
          placeholder="you@company.com"
          icon={emailIcon}
          autoFocus
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />

        <AppButton type="submit" variant="primary" size="lg" fullWidth disabled={status.loading}>
          {status.loading ? 'Sending…' : 'Send reset link'}
        </AppButton>

        {status.message ? (
          <div className={`auth-alert ${status.error ? 'auth-alert-error' : 'auth-alert-success'}`}>
            {status.message}
          </div>
        ) : null}
      </form>
    </AuthLayout>
  );
}

export default ForgotPassword;